import $ from 'jquery';
import styles from './theme1.less';
import BScroll from '@better-scroll/core';
import { iconfont } from '../../utils/utils';
const defaultParams = {
  data: null,
  defaultSceneName: null, //初始化
  isShow: false,
  onPanoClick: function() {},
};

class SceneList {
  constructor(props) {
    const { wrapper, ...params } = props;
    this.wrapper = wrapper;
    this.params = {
      ...defaultParams,
      ...params,
    };
    this.activePano = null; //激活的 pano 对象
    this.curGroups = []; //激活的pano 所在的所有分组id
    this.visitedPanos = []; //访问过的场景id
    const { data } = this.params;
    if (!data || !data.length) return;

    // if (autoShow) {
    //   this.show();
    // }
    this.isShow = params.autoShow ? true : false;
    this._initData();
    this._initDom();
    // $(document).on('click', e => {
    //   var list = $(`.${styles['scene-list-wrapper']}`);
    //   if (!list.is(e.target) && list.has(e.target).length === 0) {
    //     // 可以在这里关闭弹窗
    //     if (this.isShow) {
    //       console.log('guanbi');
    //       this.hide();
    //     }
    //   }
    // });

    setTimeout(() => {
      if (params.autoShow) {
        this.show();
      } else {
        this.$dom.css('display', 'none');
      }
    }, 40);
  }
  _initData() {
    const { defaultSceneName, data } = this.params;
    let curPano;
    //有默认值设置默认场景,没有时获取第一个场景为默认场景
    if (defaultSceneName) {
      curPano = this._getPanoByName(defaultSceneName);
    } else {
      curPano = this._getFirstPano(data);
    }
    if (!curPano) return;
    this._setCurPano(curPano);
  }
  _initDom() {
    this.$dom = this._createWrapper();
    this._initList();
    $(this.wrapper).append(this.$dom);
  }

  _createWrapper() {
    return $(
      `<div class="${styles['scene-list-wrapper']} ${styles['scene-list-wrapper-theme1']} scene-list"></div>`,
    );
  }

  _initList() {
    //生成所有分组
    const { data } = this.params;
    const _this = this;
    this._createRelateGroupList(data, 0);
    //事件
    $(document).on('click', `.${styles['pano-wrapper']}`, function() {
      _this._handlePanoClick($(this));
    });
    $(document).on('click', `.${styles['group-wrapper']}`, function() {
      _this._handleGroupClick($(this));
    });
    // $(document).on('touchend', `.${styles['pano-wrapper']}`, function() {
    //   _this._handlePanoClick($(this));
    // });
    // $(document).on('touchend', `.${styles['group-wrapper']}`, function() {
    //   _this._handleGroupClick($(this));
    // });
  }

  /**
   * @description: 生成当前list及其所所有下级list
   * @param {array} list - 多级列表
   * @param {number} index - 从第几级开始生成
   * @param {object} parent - 父级
   */

  _createRelateGroupList(list, index = 0, parent) {
    this.index = index;
    let $list;
    //当前分组list
    if (list.length == 1 && list[0].children) {
      //只有一个分组，且有下级分组时，渲染下级分组
      $list = this._createRelateGroupList(list[0].children, this.index, parent);
      return;
    } else if (list.length == 1 && list[0].scenes) {
      //只有一个分组，没有下级分组时，渲染场景列表
      $list = this._createPanoList(list[0].scenes, list[0].id);
      return;
    } else {
      $list = this._createGroupList(list, this.index, parent);
    }

    this.$dom.prepend($list);
    //下一级分组或场景list
    const next = list.find(el => this.curGroups.indexOf(el.id) > -1) || list[0];
    this.index++;
    if (next.children) {
      this._createRelateGroupList(next.children, this.index, next);
    } else {
      this._removePanoList();
      this._createPanoList(next.scenes, next.id);
    }
  }
  _removePanoList() {
    if (this.$panoList) {
      this.$panoList.remove();
      this.$panoList = null;
    }
  }

  _createPanoList(list, pid) {
    this.curPanoList = list;
    let $wrapper = $(`
      <div class="${styles['panos-wrapper']} ${styles['list-wrapper']} ${
      this.isShow ? styles['show'] : ''
    }">
      <div class="pano-view-scrollX-wrapper">
        <div class="pano-view-scrollX-content"></div>
      </div>
    </div>`);
    let $ul = $('<ul></ul>');
    list && list.forEach((el, i) => {
      let $li = $('<li></li>');
      $li.append(
        this._getPanoItem({
          item: el,
          index: i,
          pid: pid,
        }),
      );
      $ul.append($li);
    });

    if (this.$panoList) {
      const content = this.$panoList.find('.pano-view-scrollX-content');
      content.html('').append($ul);
    } else {
      $wrapper.find('.pano-view-scrollX-content').append($ul);
      this.$panoList = $wrapper;
      this.$dom.prepend(this.$panoList);
    }

    setTimeout(() => {
      this._intiScroll($wrapper.find('.pano-view-scrollX-wrapper').get(0));
    }, 20);

    return $wrapper;
  }

  _createGroupList(list, index, parent) {
    //index 当前列表的index
    if (!list) return;
    //生成一个列表
    let $wrapper = $(`
      <div 
      class="${styles['groups-wrapper']} ${styles['list-wrapper']} ${
      this.isShow ? styles['show'] : ''
    }" 
      data-index="${index}">
      <div class="pano-view-scrollX-wrapper">
        <div class="pano-view-scrollX-content"><ul></ul></div>
      </div>
    </div>`);
    const isIncludeActiveGroup = list.find(el => this.curGroups.indexOf(el.id) > -1) ? true : false;
    list.forEach((el, i) => {
      let $li = $('<li></li>');
      //生成分组item
      $li.append(
        this._getGroupItem({
          item: el,
          pIndex: index,
          index: i,
          parent: parent,
          focusFirst: !isIncludeActiveGroup,
        }),
      );
      $wrapper.find('ul').append($li);
    });

    setTimeout(() => {
      this._intiScroll($wrapper.find('.pano-view-scrollX-wrapper').get(0));
    }, 20);
    return $wrapper;
  }

  _getGroupItem(params) {
    const { item, focusFirst, pIndex, index, parent } = params;
    //生成分组item
    if (!item) return;
    const { name, id, thumb } = item;
    const isCurGroup = this.curGroups.indexOf(id) > -1 ? true : false; //是否是当前激活全景所在的分组
    let $item = $(`
    <div 
    class="${styles['group-wrapper']} ${styles['item-wrapper']} ${
      isCurGroup ? styles['active'] : ''
    } ${focusFirst && index == 0 ? styles['active'] : ''}" 
    data-group="${id}" data-parent="${
      parent ? parent.id : 0
    }"  data-name="${name}" title="${name}" data-index="${pIndex},${index}">
      <div 
      class="${styles['group-item']} 
      ${styles['list-item']}" 
      style="background-image:url('${thumb}')">
        <div class="${styles['group-name']} ${styles['item-name']}"><span>${name}</span></div>
      </div>
    </div>`);
    return $item;
  }

  _getPanoItem(params) {
    const { item, pid } = params;
    //生成全景item
    if (!item) return;
    const { name, id, thumb, scene_name, group_id } = item;
    const isActivePano = this.activePano && this.activePano.id == id ? true : false;
    const isVisitedPano = this.visitedPanos.indexOf(id) > -1 ? true : false;

    let $item = $(`
      <div 
      class="${styles['pano-wrapper']} ${styles['item-wrapper']} ${
      isActivePano ? styles['active'] : ''
    } ${isVisitedPano ? styles['visited'] : ''}" 
      data-pano="${id}" data-parent="${group_id}"  data-name="${scene_name}" title="${name}">
      <div 
      class="${styles['pano-item']} ${styles['list-item']}" 
      style="background-image:url('${thumb.url}')">
        ${
          isVisitedPano
            ? `<span class="${styles['visited-icon']}">${iconfont('icondui')}</span>`
            : ''
        }
          <div class="${styles['pano-name']} ${styles['item-name']}"><span>${name}</span></div>
        </div>
      </div>`);
    return $item;
  }

  _handlePanoClick($pano) {
    const name = $pano.attr('data-name');
    const pano = this._getPanoByName(name);
    this._changePano(pano);
    this.params.onPanoClick(name);
  }

  _changePano(pano) {
    this._setCurPano(pano);
    this._createPanoList(this.curPanoList, pano.group_id);
  }

  _setCurPano(pano) {
    this.activePano = pano;
    this.visitedPanos.push(pano.id);
    this._getParentsIdById(pano.group_id);
  }

  changeSceneByName(sceneName) {
    const curpano = this._getPanoByName(sceneName);
    if (!curpano) return;
    //如果场景在当前分组重新渲染场景列表,其他情况全部重新渲染
    if (this.curGroups.indexOf(curpano.group_id) > -1) {
      this._changePano(curpano);
    } else {
      const { data } = this.params;
      this._setCurPano(curpano);
      this.$dom.html('');
      this._createRelateGroupList(data, 0);
    }
  }

  _handleGroupClick($group) {
    //分组不全部重新渲染 只渲染当前及其下级
    const dataIndex = $group.attr('data-index').split(',');
    const groupId = $group.attr('data-group');
    const curGroup = this._getGroupById(groupId, this.params.data);
    const rowIndex = Number(dataIndex[0]);
    const colIndex = Number(dataIndex[1]);
    const listLength = $(`.${styles['groups-wrapper']}`).length;
    //移除旧的所有下级分组
    this._removeGroups(listLength - rowIndex - 1);
    $group
      .parents(`.${styles['list-wrapper']}`)
      .find(`.${styles['item-wrapper']}`)
      .removeClass(styles['active']);

    $group.addClass(styles['active']);
    //移除class
    //生成新的所有下级
    // $group.addClass(styles['active']);
    if (curGroup && curGroup.children) {
      this._createRelateGroupList(curGroup.children, rowIndex + 1);
    } else if (curGroup && curGroup.scenes) {
      this._removePanoList();
      this._createPanoList(curGroup.scenes, curGroup.id);
    }
  }

  //根据场景名查找场景
  _getPanoByName(name) {
    let item;
    const { data } = this.params;
    function tree(data, name) {
      for (let index = 0; index < data.length; index++) {
        if (item) break;
        const el = data[index];
        if (el.children) {
          tree(el.children, name);
        } else {
          item = el.scenes.find(scene => scene.scene_name == name);
          if (item) break;
        }
      }
    }
    tree(data, name);
    return item;
  }
  //获取第一个场景
  _getFirstPano(data) {
    if (!data) return;
    let item;
    function tree(data) {
      for (let index = 0; index < data.length; index++) {
        if (item) break;
        const el = data[index];
        if (el.children) {
          tree(el.children);
        } else {
          item = el.scenes ? el.scenes[0] : null;
          if (item) break;
        }
      }
    }
    tree(data, name);
    return item;
  }
  //根据当前分组id查找所有父级分组id
  _getParentsIdById(id) {
    this.curGroups = [];
    this.curGroups = this._familyTree(this.params.data, id).map(el => el.id);
  }

  //根据分组id查找分组
  _getGroupById(id, data) {
    if (!data) return;
    let cur;
    for (let index = 0; index < data.length; index++) {
      const el = data[index];
      if (el.id == id) {
        cur = el;
      } else {
        if (el.children && !cur) {
          cur = this._getGroupById(id, el.children);
        }
      }
      if (cur) return cur;
    }
  }

  //根据子级id查所有父级的id
  _familyTree(arr1, id) {
    const temp = [];
    const tree = function(arr, id) {
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        if (item.id == id) {
          temp.push(item);
          tree(arr1, item.pid);
          break;
        } else {
          if (item.children) {
            tree(item.children, id);
          }
        }
      }
    };
    tree(arr1, id);
    return temp;
  }

  _removeGroups(index) {
    for (let i = 0; i < index; i++) {
      $(this.$dom.find(`.${styles['groups-wrapper']}`)[0]).remove();
    }
  }

  _intiScroll(scrollWrapper) {
    new BScroll(scrollWrapper, {
      scrollX: true,
      click:true
    });
  }
  show() {
    const lists = this.$dom.find(`.${styles['list-wrapper']}`);
    this.$dom.css('display', 'block');
    lists.removeClass(styles['hide']).addClass(styles['show']);
    this.isShow = true;
  }
  hide() {
    const lists = this.$dom.find(`.${styles['list-wrapper']}`);
    lists.removeClass(styles['show']).addClass(styles['hide']);
    setTimeout(() => {
      this.isShow = false;
      this.$dom.css('display', 'none');
    }, 250);
  }
  toggle() {
    if (this.isShow) {
      this.hide();
    } else {
      this.show();
    }
  }
}

export default SceneList;
